import { Table } from './Table';
import { NormalTable } from './NormalTable';
Table.Normal = NormalTable;
export default Table;
